import { z } from 'zod';

export const ProfileViewPersonDto = z.object({
  userId: z.uuid(),
  displayName: z.string(),
  photoUrl: z.string().nullable(),
  viewedAt: z.iso.datetime(),
});
export type ProfileViewPersonDto = z.infer<typeof ProfileViewPersonDto>;

/** Строка на «Я»: без отметки «прочитано». Пустой total прячет блок. */
export const ProfileViewsPreviewDto = z.object({
  total: z.number().int().nonnegative(),
  unseenCount: z.number().int().nonnegative(),
  people: z.array(ProfileViewPersonDto).max(3),
});
export type ProfileViewsPreviewDto = z.infer<typeof ProfileViewsPreviewDto>;

/** Список на /profile/views. unseenCount — сколько было новых до открытия. */
export const ProfileViewsPageDto = z.object({
  unseenCount: z.number().int().nonnegative(),
  items: z.array(ProfileViewPersonDto),
});
export type ProfileViewsPageDto = z.infer<typeof ProfileViewsPageDto>;
